import {
    GetHohoInfoParams,
    SaveStopParams,
    GetStopLanguagesParams,
    SaveHohoInfoParams,
    UpdateHohoVisibilityParams,
    DeleteStopAPIParams,
    GetBusesForTrackParams,
    AffiliateBusParams,
    UnaffiliateBusParams,
} from "../types/requestInputs";
import { GetHohoInfoResponse, GetStopLanguagesResponse, GetBusesForTrackResponse } from "../types/requestsOutputs";
import { MessageResponse } from "../types/types";
import { fetchAPI } from "./utils";

export const getHohoInfo = async ({ token, trackId }: GetHohoInfoParams): Promise<GetHohoInfoResponse> => {
    return fetchAPI("/get-hoho-tracking", "POST", { trackId }, token);
};

// Save stop details
export const saveStop = async ({
    token,
    trackId,
    waypointId,
    latitude,
    longitude,
    address,
    position,
    language,
    name,
    schedule,
    pictureUrl,
    hotInfoIds,
}: SaveStopParams): Promise<String> => {
    return fetchAPI<String>(
        "/save-stop",
        "POST",
        {
            trackId,
            waypointId,
            latitude,
            longitude,
            address,
            position,
            language,
            name,
            schedule,
            pictureUrl,
            hotInfoIds,
        },
        token,
    );
};

// Get available languages for a stop
export const getStopLanguages = async ({
    token,
    waypointId,
}: GetStopLanguagesParams): Promise<GetStopLanguagesResponse> => {
    return fetchAPI<GetStopLanguagesResponse>("/get-stop-languages", "POST", { waypointId }, token);
};

// Save Hop-On Hop-Off (HoHo) tracking information
export const saveHohoInfo = async ({
    token,
    trackId,
    busColor,
    busLineColor,
    frequency,
    isDisplay,
}: SaveHohoInfoParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>(
        "/save-hoho-tracking",
        "POST",
        { trackId, busColor, busLineColor, frequency, isDisplay },
        token,
    );
};

export const updateHohoVisibility = async ({
    token,
    id,
    displayMap,
}: UpdateHohoVisibilityParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/update-hoho-visibility", "POST", { id, displayMap }, token);
};

// Get buses split into those affiliated to the track and those available to affiliate
export const getBusesForTrack = async ({
    token,
    trackId,
}: GetBusesForTrackParams): Promise<GetBusesForTrackResponse> => {
    return fetchAPI<GetBusesForTrackResponse>("/get-buses-for-track", "POST", { trackId }, token);
};

// Affiliate (or reassign) a bus to the given track
export const affiliateBus = async ({ token, trackId, busId }: AffiliateBusParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/affiliate-bus", "POST", { trackId, busId }, token);
};

// Remove a bus's affiliation from any track
export const unaffiliateBus = async ({ token, busId }: UnaffiliateBusParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/unaffiliate-bus", "POST", { busId }, token);
};

export const deleteStopAPI = async ({ token, trackId, waypointId }: DeleteStopAPIParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/delete-stop", "POST", { trackId, waypointId }, token);
};
